export default __webpack_public_path__ + "media/images/play-bg-5ce60cbe1cf8bf998e138907cf11958f.png";